import { format, parseISO } from "date-fns";

import STRINGS from "../../../../../CaseFollowUps/components/utils/strings";

const emptyString = STRINGS.EMPTY;

const formattedDate = (value) => {
  if (!value || value === undefined || value === null) {
    return emptyString;
  }
  if (value === "" || value === " ") {
    return emptyString;
  }
  return format(parseISO(value), "M/d/yyyy");
};

const formattedTime = (value) => {
  if (!value || value === undefined || value === null) {
    return emptyString;
  }
  if (value === "" || value === " ") {
    return emptyString;
  }
  return format(parseISO(value), "h:mm aaa");
};

const separator = () => {
  return " ";
};

const DateTimeModel = (date) => {
  return formattedDate(date).toString() + separator() + formattedTime(date).toString();
};
export default DateTimeModel;
